import { TechnicalReviewLogDetail } from './technical-review-log-detail.model';

export class TechnicalReviewLogSection {
  logId: string;
  order: number;
  logTitle: string;

  details: TechnicalReviewLogDetail[];
}
